{
  "pageTitle": "Rezerwacje",
  "status": {
    "SOFT_RESERVATION": "Wstępna",
    "HARD_RESERVATION": "Potwierdzona",
    "SOLD": "Sprzedana",
    "OPTION": "Stałka"
  },
  "columns": {
    "status": "Status",
    "mediaUnit": "Nośnik",
    "dateFrom": "Od",
    "dateTo": "Do",
    "holder": "Rezerwujący",
    "offer": "Oferta",
    "source": "Źródło",
    "queued": "Kol.",
    "queuedTooltip": "Liczba osób oczekujących w kolejce za tą rezerwacją",
    "deadline": "Wygasa",
    "deadlineTooltip": "Termin wygaśnięcia rezerwacji",
    "actions": "Akcje"
  },
  "deadline": {
    "neverExpires": "Nie wygasa",
    "noDeadlineSet": "Brak terminu",
    "expiredMarker": "Wygasła — oczekuje na zwolnienie"
  },
  "source": {
    "reservation_action": "Rezerwacja",
    "manual_admin": "Ręcznie (admin)",
    "xlsx_import": "Import XLSX",
    "email_reply": "Odpowiedź e-mail",
    "provider_override": "Zmiana przez dostawcę",
    "ttl_expiry": "Czas wygaśnięcia (TTL)",
    "auto_promotion": "Automatyczne zajęcie z kolejki",
    "auto_extension": "Automatyczne przedłużenie",
    "offer_version_locked": "Zablokowane wersją oferty"
  },
  "auditActions": {
    "reservation": {
      "created": "Utworzono rezerwację",
      "cancelled": "Anulowano rezerwację",
      "upgrade_hard": "Potwierdzono rezerwację",
      "close_sale": "Sprzedano",
      "override": "Zmieniono status ręcznie",
      "dates_updated": "Zmieniono daty",
      "auto_extension": "Automatyczne przedłużenie opcji",
      "queue_joined": "Dołączono do kolejki",
      "queue_left": "Opuszczono kolejkę",
      "queue_removed": "Usunięto z kolejki",
      "queue_promoted": "Przejęto rezerwację z kolejki",
      "force_release": "Wymuszono zwolnienie",
      "ttl_expiry_release": "Zwolniono po wygaśnięciu terminu (TTL)",
      "expiry_deadline_updated": "Zmieniono termin wygaśnięcia"
    }
  },
  "sortFields": {
    "status": "Status",
    "date_from": "Od",
    "date_to": "Do",
    "created_at": "Data utworzenia"
  },
  "actions": {
    "openUnit": "Otwórz nośnik",
    "openOffer": "Otwórz ofertę",
    "upgradeHard": "Zatwierdź rezerwację",
    "closeSale": "Sprzedaj",
    "editDates": "Edytuj daty",
    "cancel": "Anuluj rezerwację",
    "forceRelease": "Wymuś zwolnienie",
    "forceReleaseConfirmBody": "Zwolnisz termin należący do: {{holder}}. Kontynuować?",
    "forceReleaseConfirmUnknownHolder": "innego użytkownika",
    "releaseModeChoice": {
      "title": "Co chcesz zwolnić?",
      "wholeLabel": "Cały okres rezerwacji",
      "selectedLabel": "Tylko zaznaczone dni"
    },
    "overrideStatus": "Zmień status ręcznie",
    "blockAvailability": "Zablokuj dostępność",
    "openInPanel": "Otwórz w panelu rezerwacji",
    "extendExpiry": "Edytuj termin wygaśnięcia"
  },
  "labels": {
    "noOffer": "—",
    "totalCount": "{{count}} rezerwacji",
    "page": "Strona {{page}} z {{total}}",
    "prevPage": "Poprzednia",
    "nextPage": "Następna",
    "sort": "Sortowanie: {{field}} {{dir}}"
  },
  "filters": {
    "status": "Status",
    "offerId": "Oferta",
    "clientId": "Klient",
    "salespersonId": "Handlowiec",
    "source": "Źródło",
    "dateFrom": "Data od",
    "dateTo": "Data do",
    "clearAll": "Wyczyść filtry",
    "addFilter": "Dodaj filtr",
    "applyLabel": "Zastosuj",
    "searchLabel": "Szukaj...",
    "noOptions": "Brak opcji",
    "myReservations": "Moje rezerwacje"
  },
  "dialogs": {
    "upgradeHardTitle": "Zatwierdź rezerwację",
    "upgradeHardBody": "Czy na pewno chcesz potwierdzić tę rezerwację?",
    "closeSaleTitle": "Sprzedaj",
    "closeSaleBody": "Czy na pewno chcesz oznaczyć tę rezerwację jako sprzedaną?",
    "forceReleaseTitle": "Wymuś zwolnienie",
    "forceReleaseBody": "Czy na pewno chcesz wymusić zwolnienie tej rezerwacji?",
    "cancelConfirmBody": "Czy na pewno chcesz anulować tę rezerwację?",
    "confirmLabel": "Potwierdź",
    "cancelBtnLabel": "Anuluj",
    "cancelTitle": "Anuluj rezerwację",
    "cancelConfirmLabel": "Anuluj rezerwację",
    "cancelWillBeFreeLabel": "Zostanie zwolniony:",
    "editDatesTitle": "Edytuj daty",
    "dateRangeLabel": "Zakres dat",
    "displacementWarningLabel": "Zmiana dat może wymagać przesunięcia kolejkowanych rezerwacji.",
    "forceCheckboxLabel": "Wymuś przesunięcie (admin)",
    "saveLabel": "Zapisz",
    "overrideStatusTitle": "Zmień status ręcznie",
    "targetStatusLabel": "Nowy status",
    "reasonLabel": "Powód",
    "reasonPlaceholder": "Wpisz powód zmiany statusu...",
    "reasonRequiredLabel": "Powód jest wymagany.",
    "auditNoteLabel": "Zmiana zostanie zapisana w historii zdarzeń.",
    "overrideConfirmLabel": "Zmień status",
    "ttlExpiresAtLabel": "Termin rezerwacji (TTL)",
    "ttlExpiresAtHint": "Opcjonalnie: ustaw ręcznie termin wygaśnięcia rezerwacji tymczasowej.",
    "ttlExpiresAtPlaceholder": "Wybierz datę",
    "errorConflict": "Konflikt rezerwacji — nie można dokonać zmiany.",
    "errorDisplacement": "Zmiana wymaga przesunięcia — zaznacz opcję 'Wymuś' aby kontynuować.",
    "errorStale": "Dane są nieaktualne. Odśwież stronę i spróbuj ponownie.",
    "extendExpiryTitle": "Edytuj termin wygaśnięcia",
    "extendExpiryDescription": "Zmieniasz termin wygaśnięcia rezerwacji.",
    "extendExpiryCurrentLabel": "Aktualny termin wygaśnięcia rezerwacji",
    "extendExpiryNewLabel": "Nowy termin wygaśnięcia rezerwacji",
    "extendExpiryDatePlaceholder": "Wybierz datę",
    "extendExpiryReasonLabel": "Powód zmiany",
    "extendExpiryReasonPlaceholder": "Opisz powód zmiany terminu...",
    "extendExpiryReasonRequiredLabel": "Powód jest wymagany.",
    "extendExpirySaveLabel": "Zapisz zmianę"
  },
  "cancelBody": "Czy na pewno chcesz anulować rezerwację nośnika {{mediaUnitName}} na okres {{dateFrom}} – {{dateTo}}?",
  "unitTab": {
    "emptyState": "Brak rezerwacji dla tego nośnika",
    "emptyDescription": "Ten nośnik nie ma żadnych aktywnych rezerwacji.",
    "blockForMaintenance": "Zablokuj dostępność",
    "auditTimelineTitle": "Pełna historia zdarzeń",
    "auditTimelineShow": "Pokaż",
    "auditTimelineHide": "Ukryj",
    "auditTimelineEmpty": "Brak zdarzeń",
    "system": "system",
    "expandDetails": "Pokaż szczegóły",
    "collapseDetails": "Ukryj szczegóły",
    "queueSectionTitle": "Kolejka oczekujących",
    "queueSectionSubtitle": "Kolejność według czasu zgłoszenia",
    "queuePositionLabel": "Pozycja {{position}} w kolejce",
    "queueSpansMultiple": "Czeka też na inny okres",
    "queueOwnBadge": "Ty",
    "queueSubmittedBy": "Zgłosił:",
    "queueRemoveLabel": "Usuń z kolejki",
    "queuePromoteLabel": "Przekaż termin",
    "expiryDeadlineAudit": {
      "title": "Zmiana terminu wygaśnięcia rezerwacji",
      "actorLabel": "Zmienił:",
      "previousLabel": "Poprzedni termin:",
      "newLabel": "Nowy termin:",
      "reasonLabel": "Powód:"
    }
  },
  "tabs": {
    "overview": "Przegląd",
    "reservations": "Rezerwacje"
  },
  "waitlist": {
    "joinBtn": "Dołącz do kolejki",
    "inQueueLabel": "Jesteś #{{position}} w kolejce",
    "leaveBtn": "Opuść kolejkę",
    "sectionTitle": "{{count}} w kolejce",
    "leaveConfirmTitle": "Opuść kolejkę",
    "leaveConfirmBody": "Czy na pewno chcesz opuścić kolejkę?",
    "leaveConfirmBtn": "Tak, opuść",
    "adminRemoveTitle": "Usuń z kolejki",
    "adminRemoveBody": "Czy na pewno chcesz usunąć tę osobę z kolejki?",
    "adminRemoveBtn": "Tak, usuń",
    "adminDisplaceTitle": "Przejmij rezerwację",
    "adminDisplaceBody": "Czy na pewno chcesz wymusić zwolnienie aktywnej rezerwacji i zainstalować wybranego oczekującego?",
    "adminDisplaceBtn": "Tak, przejmij",
    "addAnotherClientLabel": "Dodaj wpis dla innego klienta",
    "newEntryTitle": "Nowy wpis",
    "cancelLabel": "Anuluj",
    "clientLabel": "Klient *",
    "brandLabel": "Brand",
    "offerLabel": "Oferta (opcjonalnie)",
    "clientPlaceholder": "Wybierz klienta",
    "brandPlaceholder": "Wybierz brand",
    "offerPlaceholder": "Wybierz ofertę",
    "clientSearchPlaceholder": "Szukaj klienta",
    "brandSearchPlaceholder": "Szukaj brandu",
    "offerSearchPlaceholder": "Szukaj oferty",
    "brandRequiredLabel": "Wybierz brand, aby dołączyć do kolejki.",
    "noBrandsLabel": "Ten klient nie ma skonfigurowanych brandów. Wybierz innego klienta.",
    "ownEntriesTitle": "Twoje wpisy w kolejce",
    "changeIdentityLabel": "Zmień",
    "expiryLabel": "Termin wygaśnięcia",
    "expiryHint": "System proponuje termin wygaśnięcia — możesz go zmienić w kalendarzu."
  },
  "queueOverview": {
    "hasQueueLabel": "Tylko z kolejką",
    "holderColumnLabel": "Handlowiec / Rezerwujący",
    "offerColumnLabel": "Klient / Oferta",
    "holderInlineLabel": "Rezerwujący",
    "salespersonLabel": "Handlowiec:",
    "joinedAtLabel": "Dołączył:",
    "promotionEtaLabel": "Przewidywany awans:",
    "brandLabel": "Marka:",
    "openFullQueueLabel": "Otwórz pełną kolejkę"
  },
  "queuePromoteDialog": {
    "title": "Przekazać termin oczekującemu?",
    "subtitle": "{{mediaUnitName}} · okno {{dateFrom}} – {{dateTo}}",
    "currentCardTitle": "Bieżąca rezerwacja — zostanie usunięta",
    "nextCardTitle": "Nowa rezerwacja — pozycja {{position}} w kolejce",
    "holderLabel": "Rezerwujący",
    "clientLabel": "Klient",
    "offerLabel": "Oferta",
    "statusLabel": "Status",
    "noClientLabel": "Brak",
    "noOfferLabel": "Brak",
    "newStatusLabel": "Wstępna (nowa)",
    "consequencesTitle": "Konsekwencje tej operacji",
    "consequenceForceReleased": "Aktualna rezerwacja (rezerwujący: {{holderUserName}}) zostanie trwale usunięta (wymuszone zwolnienie).",
    "consequenceNewReservation": "{{holderUserName}} otrzyma nową rezerwację wstępną od {{dateFrom}}, z nowym terminem TTL.",
    "consequenceNotified": "Rezerwujący {{holderUserName}} zostanie o tym poinformowany powiadomieniem w aplikacji.",
    "consequenceQueuePositionsKept": "Pozostali oczekujący zachowują swoją pozycję w kolejce.",
    "consequenceAudited": "Operacja zostanie zapisana w historii zdarzeń jako wymuszone zwolnienie i przekazanie terminu.",
    "cancelLabel": "Anuluj",
    "confirmLabel": "Tak, przekaż termin"
  },
  "availabilityWindow": {
    "dialogTitle": "Zablokuj dostępność",
    "dialogBodyIntro": "Ustaw okres dostępności dla tego nośnika, niezależny od rezerwacji klientów.",
    "dateRangeLabel": "Okres dostępności",
    "dateRangePlaceholder": "Wybierz zakres dat…",
    "stateLabel": "Stan",
    "statePlaceholder": "Wybierz stan...",
    "state": {
      "FREE": "Wolne",
      "UNAVAILABLE": "Niedostępne"
    },
    "saveLabel": "Zapisz",
    "listTitle": "Okna dostępności",
    "emptyLabel": "Brak okien dostępności dla tego nośnika.",
    "truncatedNotice": "Wyświetlono {{shown}} z {{total}}"
  },
  "toasts": {
    "availabilityWindowBlocked": "Nie można zapisać zmiany – wybrany termin jest zablokowany oknem niedostępności nośnika.",
    "availabilityWindowBlockedOnCreate": "Nie można utworzyć rezerwacji – wybrany termin jest zablokowany oknem niedostępności nośnika.",
    "reservationOverlapsWindow": "Nie można zablokować dostępności – w tym terminie istnieje aktywna rezerwacja nośnika.",
    "batchReserveConflict": "Nie udało się zarezerwować {{count}} terminów — są już zajęte przez inną rezerwację.",
    "batchReserveConflictStaleState": "Nie udało się zarezerwować {{count}} terminów — ich stan zmienił się w międzyczasie. Odśwież i spróbuj ponownie.",
    "batchReserveConflictNotFound": "Nie udało się zarezerwować {{count}} terminów — nośnik lub okres nie istnieje.",
    "batchReserveConflictForbidden": "Nie udało się zarezerwować {{count}} terminów — brak uprawnień.",
    "batchReserveConflictValidationError": "Nie udało się zarezerwować {{count}} terminów — dane rezerwacji są nieprawidłowe.",
    "batchReserveConflictMinWindowViolation": "Nie udało się zarezerwować {{count}} terminów — wybrany okres jest krótszy niż minimalny wymagany dla tego typu nośnika.",
    "batchReserveConflictMinWindowViolationExact_one": "Minimalny okres rezerwacji dla tego typu nośnika to {{minWindowDays}} dzień (wybrano {{selectedDays}}).",
    "batchReserveConflictMinWindowViolationExact_few": "Minimalny okres rezerwacji dla tego typu nośnika to {{minWindowDays}} dni (wybrano {{selectedDays}}).",
    "batchReserveConflictMinWindowViolationExact_many": "Minimalny okres rezerwacji dla tego typu nośnika to {{minWindowDays}} dni (wybrano {{selectedDays}}).",
    "batchReserveConflictMinWindowViolationExact_other": "Minimalny okres rezerwacji dla tego typu nośnika to {{minWindowDays}} dni (wybrano {{selectedDays}}).",
    "batchReserveConflictGeneric": "Nie udało się zarezerwować {{count}} terminów.",
    "batchReleaseSkipped": "Nie udało się zwolnić {{count}} rezerwacji — zostały już sprzedane, zwolnione wcześniej lub nie istnieją."
  }
}
